import React from 'react';
import { X } from 'lucide-react';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: PolicyModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" data-id="element-114">
      <div className="bg-white w-full max-w-2xl max-h-[80vh] overflow-y-auto" data-id="element-115">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between" data-id="element-116">
          <h2 className="text-2xl font-light" data-id="element-117">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 transition-colors" aria-label="Close" data-id="element-118">
            <X size={20} strokeWidth={1.5} data-id="element-119" />
          </button>
        </div>
        <div className="p-6 md:p-12 space-y-6 text-sm text-gray-600 leading-relaxed font-light" data-id="element-120">
          {children}
        </div>
      </div>
    </div>;
}